// extracted by mini-css-extract-plugin
module.exports = {"table":"style__table__ZoXGo"};